(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryController', EventFormCategoryController);

    EventFormCategoryController.$inject = ['$scope', '$state', 'EventFormCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventFormCategoryController ($scope, $state, EventFormCategory, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('FIELDS', loadAll); };
        EventConfigurationAssistant.canUse('FIELDS').then(function(allowed) { vm.canUseAssistant = allowed; });
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            EventFormCategory.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.EventFormCategorys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
